<script>
  import ApplicationLayout from '../../components/ApplicationLayout/index.svelte'
  import ItemForm from '../../components/ItemForm/index.svelte'

  let { container = {}, property, spaces = [], available_properties = [], available_containers = [], errors = {} } = $props()

  // Containers are items; render the unified form preset as a container.
  // ContainersController still speaks the old vocabulary (label /
  // parent_container_id) — map it onto the unified item shape.
  const item = $derived({
    ...container,
    name: container.label || container.name || '',
    container_id: container.parent_container_id || container.container_id || ''
  })
</script>

<svelte:head>
  <title>Add Container | Maset</title>
</svelte:head>

<ApplicationLayout>
  <ItemForm
    {item}
    {property}
    {spaces}
    containers={available_containers}
    properties={available_properties}
    {errors}
    start_as_container={true}
  />
</ApplicationLayout>
